import { render, staticRenderFns } from "./InsightsViewer.vue?vue&type=template&id=0d053f86"
import script from "./InsightsViewer.vue?vue&type=script&lang=js"
export * from "./InsightsViewer.vue?vue&type=script&lang=js"
import style0 from "./InsightsViewer.vue?vue&type=style&index=0&id=0d053f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports